import commonHeader from '../componets/CommonHeader'
import userCenterTable from '../componets/UserCenterTable'

export const baseContent = {
  components: {
    commonHeader,
    userCenterTable
  },
  data() {
    return {
      isShowLoading: true,
      tableData: [],
      totalCount: 0,
      params: {
        pageSize: 10,
        pageNumber: 1
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.params.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.params.pageNumber = val
      this.fetchData()
    },
    fetchData() {
      this.isShowLoading = true
      this.$post(this.dataUrl, this.params).then(res => {
        if (res) {
          this.tableData = res.records
          this.totalCount = res.total
        } else {
          this.tableData = []
          this.totalCount = 0
        }
      })
      this.isShowLoading = false
    }
  }
}
